import React from "react";
import type { Ref } from "react";
import { View } from "react-native";

import Text from "$src/core/components/atoms/Text/Text";
import Grid from "$src/core/components/organisms/Grid";
import type { GridRef } from "$src/core/components/organisms/Grid/types";
import type { GridSectionDto } from "$src/core/models/dto";
import $pageInsets from "$src/core/styles/page";

import $ from "./GridSection.styles";

export type GridSectionProps = {
  ref?: Ref<GridRef>;
  item: GridSectionDto;
};

const GridSection = ({ ref, item }: GridSectionProps) => (
  <View style={[$.section, $pageInsets.horizontal]}>
    {item.title && (
      <Text preset="heading2" accessibilityRole="header" numberOfLines={1}>
        {item.title}
      </Text>
    )}
    <Grid items={item.items} ref={ref} />
  </View>
);

export default GridSection;
